import { Component } from '@angular/core';

@Component({
    selector: 'app-field-selection-skeleton',
    templateUrl: './field-selection-skeleton.component.html',
    styles: ['section { padding: 0 18px 18px 18px;}'],
    standalone: false
})
export class FieldSelectionSkeletonComponent {}
